<common-modal
  *ngIf="isOpen"
  size="md"
  [isOpen]="isOpen"
  (isOpenChange)="handleIsOpenChange($event)"
  position="center"
>
  <ng-container header>
    <h2 class="font-bold">
      {{ 'sellPortfolioValueModal.title' | translate }}
    </h2>
  </ng-container>
  <ng-container body>
    <div>
      <span>
        {{ 'sellPortfolioValueModal.text' | translate }}
      </span>
      <common-currency-input
        [label]="'sellPortfolioValueModal.value' | translate"
        [item]="value"
        (itemChange)="onValueChange($event)"
        [required]="true"
        [min]="0"
        [max]="maxValue"
      ></common-currency-input>
      <div class="flex justify-end">
        <span>{{ 'sellPortfolioValueModal.maxValue' | translate }}</span>
        <span class="ml-2">{{ maxValue | currency }}</span>
      </div>
      <div class="flex justify-end">
        <span>{{ percentage / 100 | percent: '0.2-2' }}</span>
        <span class="ml-2">/ 100%</span>
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <button (click)="onCloseClick()" class="button-white mb-2 md:mb-0">
      {{ 'global.close' | translate }}
    </button>
    <button (click)="onSellPortfolioValue()" class="button mb-2 md:mb-0">
      {{ 'sellPortfolioValueModal.apply' | translate }}
    </button>
  </ng-container>
</common-modal>
